import { render } from "./NewTask.vue?vue&type=template&id=1aaa1979&scoped=true"
import script from "./NewTask.vue?vue&type=script&lang=js"
export * from "./NewTask.vue?vue&type=script&lang=js"

import "./NewTask.vue?vue&type=style&index=0&id=1aaa1979&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1aaa1979"

export default script